export default {
  onboardings: {
    fetching: false,
    fetched: false,
    submitting: false,
    submitted: false,
    data: null
  }
}
